import React, { FunctionComponent } from 'react'
import MatchStatus, { BasicMatchStatusProps } from '../index'

export type PlayOffMatchStatusProps = BasicMatchStatusProps & {
    /** image url of the competition, will be displayed in the headline */
    competitionImageUrl?: string
    /** alternative description of the competition logo */
    competitionImageAlt?: string
}

const PlayOffMatchStatus: FunctionComponent<PlayOffMatchStatusProps> = ({
    homeCompetitor,
    awayCompetitor,
    homeScore,
    awayScore,
    spaceTop,
    testID,
    spaceX,
    spaceBottom,
    competitionImageAlt,
    competitionImageUrl,
    headline,
}) => (
    <MatchStatus
        homeCompetitor={homeCompetitor}
        awayCompetitor={awayCompetitor}
        homeScore={homeScore}
        awayScore={awayScore}
        headline={headline}
        spaceBottom={spaceBottom}
        spaceTop={spaceTop}
        spaceX={spaceX}
        testID={testID}
        logoUrl={competitionImageUrl}
        logoAlt={competitionImageAlt}
        backgroundColor="onyx-2"
        competitorType="TEAM"
    />
)
export default PlayOffMatchStatus
